import { render, staticRenderFns } from "./GalleryReviewModal.vue?vue&type=template&id=0d7d74ac&"
import script from "./GalleryReviewModal.vue?vue&type=script&lang=js&"
export * from "./GalleryReviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports